module.exports = __webpack_public_path__ + "assets/img/18_176_big.30713024.jpg";